export const API_ENDPOINTS = {
  LOGIN: "/user/login",
  SIGNUP: "/api/register",
  GET_PROFILE: "/user/get-profile",
  FORGOT_PASSWORD_SEND_EMAIL: "/user/send-email-to-forget-password-link",
  FORGOT_PASSWORD: "/user/forget-password",
  VERIFY_FORGET_PASSWORD_TOKEN: "/user/verify-forget-password-token",
  RESEND_OTP: "/api/resend-otp",
  SEND_VERIFICATION_CODE: "/signup-request/send-otp",
  VERIFY_EMAIL: "/signup-request/verify-otp",
  GET_MAM_ADMIN: "/user/get-admins",
  ADD_ADMIN_BY_SUPERADMIN: "/user/add-admin",
  DELETE_ADMIN_BY_SUPERADMIN: "/user/delete-admin",
  GET_ALL_USERS_BY_SUPERADMIN: "/user/super-admin/get-all-users",
  RESTORE_USER_BY_SUPERADMIN: "/user/super-admin/restore-user",
  PERMANENTLY_DELETE_USER_BY_SUPERADMIN: "/user/super-admin/permanently-delete-user",
  REGISTER_CUSTOMER: "/signup-request/customer",
  REGISTER_TRAINER: "/signup-request/trainer",
  CUSTOMER_PLAN_REQUEST_GET_BY_ADMIN: "/meal-plan-requests/get-by-admin",
  CUSTOMER_PLAN_REQUEST_GET_BY_ADMIN_ID_DETAILS:
    "/meal-plan-requests/get-details-by-admin",
  CHANGE_PASSWORD: "/user/change-password",
  GET_TRAINER: "/user/get-trainers",
  GET_TRAINER_BY_ADMIN: "/user/get-trainers-by-admin",
  ADD_TRAINER_BY_ADMIN: "/user/add-trainer-by-admin",
  ADD_TRAINER_BY_SUPERADMIN: "/user/add-trainer",
  STRIPE_PLAN_GET_BY_TRAINER: "/stripe-plan/get-by-trainer",
  STRIPE_PLAN_PURCHASE_GET_BY_TRAINER: "/stripe-plan/purchase-plan-by-trainer",
  STRIPE_PLAN_UPGRADE_GET_BY_TRAINER: "/stripe-plan/changed-plan-by-trainer",
  STRIPE_PLAN_PURCHASE_GET_BY_CUSTOMER: "/stripe-plan/purchase-plan-by-customer",
  STRIPE_PLAN_UPGRADE_GET_BY_CUSTOMER: "/stripe-plan/changed-plan-by-customer",
  CUSTOMER_PLAN_REQUEST_GET_BY_TRAINER: "/meal-plan-requests/get-by-trainer",
  CUSTOMER_PLAN_REQUEST_GET_BY_TRAINER_ID_DETAILS:
    "/meal-plan-requests/get-details-by-trainer",

  GET_CUSTOMER: "/user/get-customers",
  GET_CUSTOMER_BY_ADMIN: "/user/get-customers-by-admin",
  GET_CUSTOMER_BY_TRAINER: "/user/get-customers-by-trainer",
  UPDATE_CUSTOMER_PROFILE: "/user/update-customer-profile",

  // UPDATE_TRAINER_PROFILE: "/user/update-trainer-profile",
  // UPDATE_ADMIN_PROFILE: "/user/update-admin-profile",
  // UPDATE_SUPERADMIN_PROFILE: "/user/update-superadmin-profile",
  UPDATE_PROFILE: "/user/update-profile",
  ADD_CUSTOMER_BY_ADMIN: "/user/add-customer-by-admin",
  ADD_CUSTOMER_BY_SUPERADMIN: "/user/add-customer",
  ADD_CUSTOMER_BY_TRAINER: "/user/add-customer-by-trainer",
  DELETE_CUSTOMER_BY_SUPERADMIN: "/user/delete-customer",
  DELETE_CUSTOMER_BY_ADMIN: "/user/delete-customer-by-admin",
  DELETE_CUSTOMER_BY_TRAINER: "/user/send-delete-customer-request-by-trainer",
  DELETE_TRAINER_BY_ADMIN: "",

  GET_CHAT: "/message/get",
  EDIT_CUSTOMER: "/user/edit-customer",
  TEMPLATE_DELETE: "/template/delete",
  GET_STRIPE_PLAN: "/stripe-plan/get",
  ADD_STRIPE_PLAN: "/stripe-plan/add",
  EDIT_STRIPE_PLAN: "/stripe-plan/edit",
  ARCHIVE_STRIPE_PLAN: "/stripe-plan/archive",

  GET_MEAL_PLAN_CATEGORY: "/meal-plan-categories/get",
  CREATE_MEAL_PLAN: "/meal-plan/create",
  EDIT_MEAL_PLAN: "/meal-plan/edit",
  CREATE_MEAL_PLAN_BY_TRAINER: "/meal-plan/create-by-trainer",
  CREATE_MEAL_PLAN_BY_CUSTOMER: "/meal-plan/create-by-customer",
  GET_DIET_PLANS: "/meal-plan/get-plans",
  GET_DIET_PLAN: "meal-plan/get",
  GET_FOOD_CATEGORIES: "/food/get-categories",
  GET_FOOD_CATEGORIES_WISE_RECIPE_COUNTS:
    "/food/get-category-wise-recipe-counts",
  CREATE_FOOD: "/food/create",
  CREATE_NEW_SERVING_UNIT: "/food/add-serving-unit",
  CREATE_RECIPE: "/food/create-recipe",
  GET_TEMPLATE_PLAN: "/template/get-details",
  GET_TEMPLATE_PLANS: "/template/get-own",
  GET_ALL_TEMPLATE_PLANS: "/template/get-all",
  CREATE_TEMPLATE_PLAN: "/template/create",
  GET_SERVING_UNITS: "/food/get-serving-units",
  GET_MEAL_SLOT_NAMES: "/default-slots/get",
  GET_FOOD_DATA: "/food/get-details",
  EDIT_SERVING: "/food/edit-food-serving",
  EDIT_FOOD_INFO: "/food/edit",
  DELETE_SERVING: "/food/delete-food-serving",
  ADD_FOOD_SERVING: "/food/add-food-serving",
  UPDATE_FOOD_SERVING_MEAL_PLAN: "/meal-plan/update-food-serving",
  UPDATE_RECIPE_SERVINGS: "/food/edit-recipe-serving",
  SAVE_AND_FINISH_RECIPE: "/food/save-and-finish-recipe",
  EDIT_RECIPE: "/food/edit-recipe",
  USE_RECIPE: "/food/use-recipe",
  DELETE_FOOD_IN_RECIPE: "/food/delete-recipe-ingredient",
  UPDATE_FOOD_SERVING_TEMPLATE_PLAN: "/template/update-food-serving",
  GET_FOOD: "/food/get",
  GET_FOOD_RECIPE_MANAGE: "/food/get-to-manage",
  GET_RECIPE_LIST: "/food/get-recipe-dropdown",
  FAV_FOOD: "/food/get-favorite",
  FAV_MEAL: "/meal-plan/get-favorite-meal",
  RECENT_FAV_MEAL: "/user/get-recent-selections",
  ADD_FAV_MEAL_PLAN: "/meal-plan/add-favorite-meal-in-plan",
  ADD_FAV_MEAL_TEMPLATE_PLAN: "/template/add-favorite-meal-in-template",
  GET_FAV_MEAL_DETAILS: "/meal-plan/get-meal-slot-details",
  ADD_FOOD: "/meal-plan/add-food",
  ADD_RECIPE_FOOD: "/food/add-recipe-ingredient",
  ADD_FOOD_IN_TEMPLATE: "/template/add-food",
  ADD_FOOD_BY_TRAINER: "/meal-plan/add-food-by-trainer",
  ADD_FOOD_BY_CUSTOMER: "/meal-plan/add-food-by-customer",
  DELETE_MEAL_PLAN_BY_TRAINER: "/meal-plan/delete-plan-by-trainer",
  GET_PLANS_BY_CUSTOMER: "meal-plan/get-plans-by-customer",
  GET_DIET_PLANS_BY_TRAINER: "meal-plan/get-plans-by-trainer",
  GET_MEAL_BY_CUSTOMER: "/meal-plan/get-by-customer",
  SEND_EMAIL_MEAL_PLAN: "/meal-plan/send-pdf-to-email",
  GET_MEAL_BY_TRAINER: "/meal-plan/get-by-trainer",
  GET_MEAL_PLAN_BY_ADMIN: "/meal-plan/get",

  GET_STRIPE_PLAN_CUSTOMER: "/stripe-plan/get-by-customer",
  GET_STRIPE_PLAN_CUSTOMER_PLANS: "/stripe-plan/get-customer-plans",
  ADD_MEAL_PLAN_REQUEST: "/meal-plan-requests/send",

  GET_STRIPE_PLAN_INVOICES: "/stripe-plan/get-invoices",
  GET_STRIPE_PLAN_UPCOMING_INVOICES: "/stripe-plan/get-upcoming-invoice",
  STRIPE_VERIFY_COUPON_CODE: "/stripe-plan/verify-coupon-code",
  CONFIRM_STRIPE_SUBSCRIPTION: "/stripe-plan/confirm-subscription",
  CANCEL_PENDING_STRIPE_SUBSCRIPTION: "/stripe-plan/cancel-pending-subscription",

  DELETE_FOOD_BY_TRAINER: "/meal-plan/remove-food-by-trainer",
  DELETE_FOOD_BY_CUSTOMER: "/meal-plan/remove-food-by-customer",
  DELETE_FOOD_BY_ADMIN: "/meal-plan/remove-food",
  MANGE_FAV_FOOD: "/food/manage-favorite",
  MANGE_FAV_MEAL: "/meal-plan/manage-favorite-meal",
  GET_FOOD_SERVINGS: "/food/get-food-servings",
  ADD_MEAL_SLOT_BY_TRAINER: "/meal-plan/add-plan-slot-by-trainer",
  ADD_MEAL_SLOT_BY_CUSTOMER: "/meal-plan/add-plan-slot-by-customer",
  ADD_MEAL_SLOT_BY_ADMIN: "/meal-plan/add-plan-slot",
  ADD_TEMPLATE_MEAL_SLOT: "/template/add-slot",
  EDIT_MEAL_SLOT_BY_TRAINER: "/meal-plan/edit-plan-slot-by-trainer",
  EDIT_MEAL_SLOT_BY_CUSTOMER: "/meal-plan/edit-plan-slot-by-customer",
  EDIT_MEAL_SLOT_BY_ADMIN: "/meal-plan/edit-plan-slot",
  DELETE_MEAL_SLOT_BY_TRAINER: "/meal-plan/delete-plan-slot-by-trainer",
  DELETE_MEAL_SLOT_BY_CUSTOMER: "/meal-plan/delete-plan-slot-by-customer",
  DELETE_MEAL_SLOT_BY_ADMIN: "/meal-plan/delete-plan-slot",
  DELETE_TEMPLATE_SLOT: "/template/delete-slot",

  GET_MEAL_SLOT_BY_CUSTOMER: "/meal-plan/get-slot-by-customer",

  TRANSFER_ADMIN_TO_ADMIN: "/user/transfer-data-admin-to-admin",
  MEAL_PLAN_SAVE_BY_ADMIN: "/meal-plan/save-and-finish",
  SAVE_MEAL_PLAN_BY_TRAINER: "/meal-plan/save-and-finish-by-trainer",
  SAVE_MEAL_PLAN_BY_CUSTOMER: "/meal-plan/save-and-finish-by-customer",
  SAVE_TEMPLATE_PLAN: "/template/save-and-finish",
  EDIT_TEMP_SLOT: "/template/edit-slot",

  GET_MEAL_PLAN_DETAILS_BY_CUSTOMER: "/meal-plan-requests/get-by-customer",
  GET_DELETE_CUSTOMER_REQUESTS_BY_ADMIN:
    "/user/get-delete-customer-requests-by-admin",
  UPDATE_DELETE_CUSTOMER_REQUEST_BY_ADMIN:
    "/user/update-delete-customer-request-by-admin",

  GET_REPORT_COUNT: "/report/get-count",
  GET_REWARD_COUNT: "/report/get-count",
  GET_CUSTOMER_PAYMENT: "/report/get-customer-payments",
  GET_CUSTOMER_PAYMENT_COUNT: "/report/get-customer-payment-count",
  GET_TRAINER_PAYMENT: "/report/get-trainer-payments",
  GET_TRAINER_PAYMENT_COUNT: "/report/get-trainer-payment-count",
  GET_TRAINER_PERFORMANCE: "/report/get-trainer-performance",
  GET_REPORT_GET_TRAINERS: "/report/get-trainers",
  GET_REPORT_GET_CUSTOMERS: "/report/get-customers",
  GET_MEAL_PLANS: "/report/get-meal-plans",
  GET_STRIPE_COUPONS: "/stripe-coupon",
  DELETE_STRIPE_COUPON: "/stripe-coupon",
  ADD_STRIPE_COUPON: "/stripe-coupon",
  ADD_STRIPE_PROMO: "/stripe-coupon/create-promotion-code",

  USER_GET_ADMIN_BY_SUPERADMIN: "/user/get-admin",
  USER_GET_TRAINER_BY_SUPERADMIN: "/user/get-trainer",
  USER_GET_TRAINER_BY_ADMIN: "/user/get-trainer-by-admin",
  USER_GET_CUSTOMER_BY_TRAINER: "/user/get-customer-by-trainer",
  USER_GET_CUSTOMER_BY_SUPERADMIN: "/user/get-customer",
  USER_GET_CUSTOMER_BY_ADMIN: "/user/get-customer-by-admin",
  USER_EIDT_ADMIN_BY_SUPERADMIN: "/user/edit-admin",
  USER_EIDT_TRAINER_BY_SUPERADMIN: "/user/edit-trainer",
  USER_EIDT_TRAINER_BY_ADMIN: "/user/edit-trainer-by-admin",
  USER_EIDT_CUSTOMER_BY_SUPERADMIN: "/user/edit-customer",
  USER_EIDT_CUSTOMER_BY_ADMIN: "/user/edit-customer-by-admin",
  USER_EIDT_CUSTOMER_BY_TRAINER: "/user/edit-customer-by-trainer",
  USER_DELETE_TRAINER: "/user/delete-trainer",
  USER_DELETE_TRAINER_BY_ADMIN: "/user/delete-trainer-by-admin",

  GET_SIGNUP_REQUEST: "/signup-request",
  UPDATE_REQUEST: "/signup-request",
  GET_SIGNUP_REQUEST_BY_ID: "/signup-request/get-by-id",
  GET_TRAINER_STRIPE_PLANS: "/stripe-plan/get-trainer-plans",
  DELETE_FOOD_ITEM: "/food/delete",
  DISASSOCIATE_CUSTOMER: "/user/disassociate-customer",
  DELETE_MEAL_PLAN: "/meal-plan/delete",
  DELETE_MEAL_PLAN_BY_CUSTOMER: "/meal-plan/delete-plan-by-customer",
  DELETE_TEMPLATE: "/template/delete",
  REMOVE_FOOD: "/template/remove-food",
  SAVE_TEMP_BY_ADMIN: "/meal-plan/use-template-by-admin",
  SAVE_TEMP_BY_TRAINER: "/meal-plan/use-template-by-trainer",
  SAVE_TEMP_BY_CUSTOMER: "/meal-plan/use-template-by-customer",

  GET_FOOD_SHOPPING_LIST: "/meal-plan/get-food-shopping-list",
  UPDATE_FOOD_HAVE_IT: "/meal-plan/update-food-have-it",
  GET_ADMIN_DROPDOWN_LIST: "/user/get-admin-dropdown-list",
  GET_TRAINER_DROPDOWN_LIST: "/user/get-trainer-dropdown-list",

  REPORT_EXPORT_TRAINER_PERFORMANCE: "/report/export-trainer-performance",
  REPORT_EXPORT_TRAINERS: "/report/export-trainers",
  REPORT_EXPORT_CUSTOMERS: "/report/export-customers",
  REPORT_EXPORT_MEAL_PLANS: "/report/export-meal-plans",
  REPORT_EXPORT_USER_PAYMENTS: "/report/export-user-payments",
  GET_USER_DROPDOWN_LIST: "/user/get-user-dropdown-list",
  GET_ALL_PAYMENTS: "/report/get-all-payments",

  GET_REFERRAL_LINK: "/user/get-referral-link",
  CONFIGURATIONS_REFERRAL_GET: "/configurations/get",
  CONFIGURATIONS_REFERRAL_UPDATE: "/configurations/update",

  GET_SYSTEM_GENERATED_RECOMMENDATION:
    "/template/get-system-generated-recommendation",
  GET_USER_REWARDS: "/reward/get-user-rewards",
  GET_TRAINER_REWARDS: "/reward/get",
  GET_TRAINER_REWARDS_COUNT: "/reward/get-counts",
  UPDATE_REWARD_BY_SUPERADMIN: "/reward/update",
  REWARD_USERS_DROPDOWN: "/reward/users",

  GET_PARENT_DETAILS: "/user/get-parent-details",
  SWAP_FOOD: "/meal-plan/swap-food",

  STRIPE_CUSTOMER_PLAN_CANCEL_SUBSCRIPTION: "/stripe-plan/cancel-subscription",

  COPIED_DAY: "/meal-plan/copied-day",
  TEMPLATE_COPIED_DAY: "/template/copied-day",
  COPIED_DAY_SLOT: "/meal-plan/copied-slot",
  TEMPLATE_COPIED_DAY_SLOT: "/template/copied-slot",

  FOOD_UPDATE_CONFIGURATIONS: "/food/update-configurations",
  FOOD_GET_FOOD_CONFIGURATION: "/food/get-food-configuration",
  MEAL_PLAN_GENERATRES: "/meal-plan-generates/generate",

  GET_TRAINER_DASHBOARD_COUNT: "/user/get-trainer-dashboard-counts",
  GET_TRAINER_REWARDS_HISTORY: "/user/get-trainer-rewards",
  GET_CUSTOMER_DSAHBORAD_COUNT: "/user/get-customer-dashboard-counts",
  GET_CUSTOMER_REWARDS_HISTORY: "/user/get-customer-rewards",
  GET_ADMIN_DASHBOARD_COUNTS: "/user/get-admin-dashboard-counts",
  SAVE_CUSTOMER_NUTRITION_DATA: "/user/save-customer-nutrition-data",

  // Blog
  BLOG_CREATE: "/blog/create",
  BLOG_EDIT: "/blog/edit/",
  BLOG_DELETE: "/blog/delete/",
  BLOG_GET_LIST_ADMIN: "/blog/get",
  BLOG_GET_DETAILS_ADMIN: "/blog/get/",
  BLOG_GET_PUBLIC_LIST: "/blog/public/get",
  BLOG_GET_PUBLIC_DETAILS: "/blog/public/get/",

  BLOG_CATEGORY_CREATE: "/blog-category/create",
  BLOG_CATEGORY_EDIT: "/blog-category/edit/",
  BLOG_CATEGORY_DELETE: "/blog-category/delete/",
  BLOG_CATEGORY_GET: "/blog-category/get",

  BLOG_TAG_GET: "/blog-tag/get",
  BLOG_TAG_DELETE: "/blog-tag/delete/",
};
